import React, { useState } from 'react';
import { LuFileText } from 'react-icons/lu';
import { PageLayout } from '../../../app/PageLayout';
import { EmptyState } from '../../../components/ui';
import { formatDate, plural, t } from '../../../i18n';
import { ptBR } from '../../../i18n/pt-BR';
import { Patient, Order } from '../types';
import { RowButton, RowSkeletons } from '../RowButton';
import { SearchField } from '../../../components/patterns/SearchField';
import { StatusBadge } from '../StatusBadge';

interface OrderListScreenProps {
  patient: Patient;
  orders: Order[];
  loading: boolean;
  onOrderSelect: (order: Order) => void;
  onBack: () => void;
}

export const OrderListScreen: React.FC<OrderListScreenProps> = ({ patient, orders, loading, onOrderSelect, onBack }) => {
  const [search, setSearch] = useState('');

  const filtered = orders.filter((order) => order.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <PageLayout
      title={patient.name}
      subtitle={plural(patient.ordersCount, ptBR.savedOrders.orderCount)}
      onBack={onBack}
    >
      <SearchField sticky value={search} onChange={setSearch} placeholder={t('savedOrders.searchOrder')} disabled={loading} />

      {loading ? (
        <div className="flex flex-col gap-2.5"><RowSkeletons /></div>
      ) : filtered.length === 0 ? (
        <EmptyState title={t('savedOrders.noOrder')} />
      ) : (
        <div className="stagger flex flex-col gap-2.5">
          {filtered.map((order) => (
            <RowButton
              key={order.id}
              square
              avatar={<LuFileText size={20} aria-hidden />}
              title={order.name || t('savedOrders.noProcedure')}
              subtitle={
                <span className="mt-1 flex flex-wrap items-center gap-2">
                  {formatDate(order.timestamp)}
                  <StatusBadge status={order.status} />
                </span>
              }
              onClick={() => onOrderSelect(order)}
            />
          ))}
        </div>
      )}
    </PageLayout>
  );
};
